/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AdditionalResourceDetailsForFinopsUtilizationAdvisor extends models.AdditionalResourceDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("AdditionalResourceDetailsForFinopsUtilizationAdvisor");
    }

    getFixupPrototypeFunction() { return AdditionalResourceDetailsForFinopsUtilizationAdvisor.fixupPrototype; }

    static newInstance(model: Partial<AdditionalResourceDetailsForFinopsUtilizationAdvisor>): AdditionalResourceDetailsForFinopsUtilizationAdvisor {
        let obj = Object.assign(new AdditionalResourceDetailsForFinopsUtilizationAdvisor(), model);
        AdditionalResourceDetailsForFinopsUtilizationAdvisor.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AdditionalResourceDetailsForFinopsUtilizationAdvisor>): AdditionalResourceDetailsForFinopsUtilizationAdvisor {
        if (!model) return null;
        return AdditionalResourceDetailsForFinopsUtilizationAdvisor.newInstance(<AdditionalResourceDetailsForFinopsUtilizationAdvisor> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AdditionalResourceDetailsForFinopsUtilizationAdvisor) {
        if (!obj) return;

        models.AdditionalResourceDetailsForFinopsUtilizationAdvisor.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AdditionalResourceDetailsForFinopsUtilizationAdvisor): boolean {
        if (models.AdditionalResourceDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AdditionalResourceDetailsForFinopsUtilizationAdvisor.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Scope of the reservation
     */
    scope: string;

    /**
     * sku name
     */
    sku: string;

    /**
     * term name
     */
    term: string;

    /**
     * Quantity
     */
    quantity: string;

    /**
     * Region Name
     */
    region: string;

    /**
     * Display Quantity
     */
    display_quantity: string;

    /**
     * Display SKU
     */
    display_sku: string;

    /**
     * LookBack Period in days
     */
    lookback_period: string;

}
